import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ReassignWorkflowInput, WorkItem, WorkItemPort } from '../domain/workflow'

const reassignWorkflow = async (
	port: WorkItemPort,
	item: WorkItem,
	input: ReassignWorkflowInput,
	ctx: ActorContext,
	notify: NotifyPort,
): Promise<WorkItem | null> => {
	if (!canActor('reassign_workflow', item, ctx)) {
		notify.error('workItem.denyReassignWorkflow')
		return null
	}
	try {
		const updated = await port.reassignWorkflow(input)
		notify.success('workItem.movedToWorkflow')
		return updated
	} catch {
		notify.error('workItem.moveFailed')
		return null
	}
}

export { reassignWorkflow }
